type Props = {
  id: string;
  title: string;
  children: any;
};

function Modal(props: Props) {
  const { id, title, children } = props;
  return (
    <div className="modal" id={id} tabIndex={-1}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div>
              {children}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" data-dismiss="modal">
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
